<app-packages-table-view [packagesAPI]="packagesAPI" [canPrintPdf]="true"
                         (printPdf)="downloadPdf()"></app-packages-table-view>